// extracted by mini-css-extract-plugin
export default {"modal":"LIlbTd968avP22igLFBv"};